/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeCommunityGoalResponse } from './ChallengeCommunityGoalResponse';
import {
    ChallengeCommunityGoalResponseFromJSON,
    ChallengeCommunityGoalResponseFromJSONTyped,
    ChallengeCommunityGoalResponseToJSON,
    ChallengeCommunityGoalResponseToJSONTyped,
} from './ChallengeCommunityGoalResponse';
import type { ChallengeFaqDetails } from './ChallengeFaqDetails';
import {
    ChallengeFaqDetailsFromJSON,
    ChallengeFaqDetailsFromJSONTyped,
    ChallengeFaqDetailsToJSON,
    ChallengeFaqDetailsToJSONTyped,
} from './ChallengeFaqDetails';
import type { ChallengeGrandPrize } from './ChallengeGrandPrize';
import {
    ChallengeGrandPrizeFromJSON,
    ChallengeGrandPrizeFromJSONTyped,
    ChallengeGrandPrizeToJSON,
    ChallengeGrandPrizeToJSONTyped,
} from './ChallengeGrandPrize';
import type { PageHeroSection } from './PageHeroSection';
import {
    PageHeroSectionFromJSON,
    PageHeroSectionFromJSONTyped,
    PageHeroSectionToJSON,
    PageHeroSectionToJSONTyped,
} from './PageHeroSection';
import type { ChallengePromotionsSectionConfig } from './ChallengePromotionsSectionConfig';
import {
    ChallengePromotionsSectionConfigFromJSON,
    ChallengePromotionsSectionConfigFromJSONTyped,
    ChallengePromotionsSectionConfigToJSON,
    ChallengePromotionsSectionConfigToJSONTyped,
} from './ChallengePromotionsSectionConfig';
import type { ChallengeTypography } from './ChallengeTypography';
import {
    ChallengeTypographyFromJSON,
    ChallengeTypographyFromJSONTyped,
    ChallengeTypographyToJSON,
    ChallengeTypographyToJSONTyped,
} from './ChallengeTypography';
import type { ChallengeSectionStyleConfig } from './ChallengeSectionStyleConfig';
import {
    ChallengeSectionStyleConfigFromJSON,
    ChallengeSectionStyleConfigFromJSONTyped,
    ChallengeSectionStyleConfigToJSON,
    ChallengeSectionStyleConfigToJSONTyped,
} from './ChallengeSectionStyleConfig';
import type { ChallengeSegment } from './ChallengeSegment';
import {
    ChallengeSegmentFromJSON,
    ChallengeSegmentFromJSONTyped,
    ChallengeSegmentToJSON,
    ChallengeSegmentToJSONTyped,
} from './ChallengeSegment';
import type { ChallengeThemeColors } from './ChallengeThemeColors';
import {
    ChallengeThemeColorsFromJSON,
    ChallengeThemeColorsFromJSONTyped,
    ChallengeThemeColorsToJSON,
    ChallengeThemeColorsToJSONTyped,
} from './ChallengeThemeColors';
import type { ChallengeDraw } from './ChallengeDraw';
import {
    ChallengeDrawFromJSON,
    ChallengeDrawFromJSONTyped,
    ChallengeDrawToJSON,
    ChallengeDrawToJSONTyped,
} from './ChallengeDraw';
import type { EligibilityConfig } from './EligibilityConfig';
import {
    EligibilityConfigFromJSON,
    EligibilityConfigFromJSONTyped,
    EligibilityConfigToJSON,
    EligibilityConfigToJSONTyped,
} from './EligibilityConfig';
import type { ChallengeEmailConfig } from './ChallengeEmailConfig';
import {
    ChallengeEmailConfigFromJSON,
    ChallengeEmailConfigFromJSONTyped,
    ChallengeEmailConfigToJSON,
    ChallengeEmailConfigToJSONTyped,
} from './ChallengeEmailConfig';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';
import type { ChallengeVideoSection } from './ChallengeVideoSection';
import {
    ChallengeVideoSectionFromJSON,
    ChallengeVideoSectionFromJSONTyped,
    ChallengeVideoSectionToJSON,
    ChallengeVideoSectionToJSONTyped,
} from './ChallengeVideoSection';
import type { ChallengeEligibilityCheckbox } from './ChallengeEligibilityCheckbox';
import {
    ChallengeEligibilityCheckboxFromJSON,
    ChallengeEligibilityCheckboxFromJSONTyped,
    ChallengeEligibilityCheckboxToJSON,
    ChallengeEligibilityCheckboxToJSONTyped,
} from './ChallengeEligibilityCheckbox';
import type { SignupMethod } from './SignupMethod';
import {
    SignupMethodFromJSON,
    SignupMethodFromJSONTyped,
    SignupMethodToJSON,
    SignupMethodToJSONTyped,
} from './SignupMethod';
import type { ChallengeContentSection } from './ChallengeContentSection';
import {
    ChallengeContentSectionFromJSON,
    ChallengeContentSectionFromJSONTyped,
    ChallengeContentSectionToJSON,
    ChallengeContentSectionToJSONTyped,
} from './ChallengeContentSection';
import type { ChallengeOnboarding } from './ChallengeOnboarding';
import {
    ChallengeOnboardingFromJSON,
    ChallengeOnboardingFromJSONTyped,
    ChallengeOnboardingToJSON,
    ChallengeOnboardingToJSONTyped,
} from './ChallengeOnboarding';
import type { PageNavbarConfig } from './PageNavbarConfig';
import {
    PageNavbarConfigFromJSON,
    PageNavbarConfigFromJSONTyped,
    PageNavbarConfigToJSON,
    PageNavbarConfigToJSONTyped,
} from './PageNavbarConfig';
import type { ChallengeEligibilityGeo } from './ChallengeEligibilityGeo';
import {
    ChallengeEligibilityGeoFromJSON,
    ChallengeEligibilityGeoFromJSONTyped,
    ChallengeEligibilityGeoToJSON,
    ChallengeEligibilityGeoToJSONTyped,
} from './ChallengeEligibilityGeo';
import type { PageSeo } from './PageSeo';
import {
    PageSeoFromJSON,
    PageSeoFromJSONTyped,
    PageSeoToJSON,
    PageSeoToJSONTyped,
} from './PageSeo';
import type { ChallengePageMode } from './ChallengePageMode';
import {
    ChallengePageModeFromJSON,
    ChallengePageModeFromJSONTyped,
    ChallengePageModeToJSON,
    ChallengePageModeToJSONTyped,
} from './ChallengePageMode';
import type { ChallengeReferralBonus } from './ChallengeReferralBonus';
import {
    ChallengeReferralBonusFromJSON,
    ChallengeReferralBonusFromJSONTyped,
    ChallengeReferralBonusToJSON,
    ChallengeReferralBonusToJSONTyped,
} from './ChallengeReferralBonus';

/**
 * Collection contains challenges that can be completed by users
 * @export
 * @interface Challenge
 */
export interface Challenge {
    /**
     * 
     * @type {string}
     * @memberof Challenge
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof Challenge
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof Challenge
     */
    updatedAt: number;
    /**
     * The title of the challenge
     * @type {string}
     * @memberof Challenge
     */
    name: string;
    /**
     * The title of the challenge on the card on DevourPlay Play tab.
     * @type {string}
     * @memberof Challenge
     */
    cardTitle?: string;
    /**
     * The description of the challenge
     * @type {string}
     * @memberof Challenge
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Challenge
     */
    backgroundImageLarge?: string;
    /**
     * 
     * @type {string}
     * @memberof Challenge
     */
    backgroundImageSmall?: string;
    /**
     * 
     * @type {string}
     * @memberof Challenge
     */
    brandLogo?: string;
    /**
     * Hex color code for the brand. Any colour the API accepts —
     * @type {string}
     * @memberof Challenge
     */
    brandColor?: string;
    /**
     * Hex color code for the brand. Any colour the API accepts —
     * @type {string}
     * @memberof Challenge
     */
    textColor?: string;
    /**
     * 
     * @type {string}
     * @memberof Challenge
     */
    disclaimerTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof Challenge
     */
    disclaimerDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Challenge
     */
    hasEnded?: boolean;
    /**
     * Whether the challenge is active
     * @type {boolean}
     * @memberof Challenge
     */
    isActive?: boolean;
    /**
     * Whether the challenge is only available to admins.
     * @type {boolean}
     * @memberof Challenge
     */
    isAdminOnly?: boolean;
    /**
     * Whether to show this challenge as a promo card on CockpitV3 and other discovery surfaces.
     * @type {boolean}
     * @memberof Challenge
     */
    showPromoCard?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Challenge
     */
    numberOfEntrants?: number;
    /**
     * 
     * @type {string}
     * @memberof Challenge
     */
    termsUrl?: string;
    /**
     * Rich text (HTML) terms and rules content for display on challenge page
     * @type {string}
     * @memberof Challenge
     */
    termsContent?: string;
    /**
     * 
     * @type {ChallengeOnboarding}
     * @memberof Challenge
     */
    onboardingSection?: ChallengeOnboarding;
    /**
     * 
     * @type {Array<ChallengeFaqDetails>}
     * @memberof Challenge
     */
    faqs?: Array<ChallengeFaqDetails>;
    /**
     * Optional per-challenge eligibility checkboxes rendered alongside 18+ and Terms in the sign-in modal. Empty/omitted means no extra checkboxes (matches default behavior).
     * @type {Array<ChallengeEligibilityCheckbox>}
     * @memberof Challenge
     */
    eligibilityCheckboxes?: Array<ChallengeEligibilityCheckbox>;
    /**
     * 
     * @type {ChallengeEligibilityGeo}
     * @memberof Challenge
     */
    eligibilityGeo?: ChallengeEligibilityGeo;
    /**
     * 
     * @type {EligibilityConfig}
     * @memberof Challenge
     */
    eligibilityConfig?: EligibilityConfig;
    /**
     * 
     * @type {Array<ChallengeSegment>}
     * @memberof Challenge
     */
    segments?: Array<ChallengeSegment>;
    /**
     * Admin-scheduled random drawings, each with own date/time, qualification mode, and reward set. Orthogonal to segments — drawing cadence is independent of scoring windows.
     * @type {Array<ChallengeDraw>}
     * @memberof Challenge
     */
    draws?: Array<ChallengeDraw>;
    /**
     * 
     * @type {string}
     * @memberof Challenge
     */
    prizePoolFeatureImage?: string;
    /**
     * 
     * @type {number}
     * @memberof Challenge
     */
    titleFontSize?: number;
    /**
     * The slug of the brand map associated with this challenge.
     * @type {string}
     * @memberof Challenge
     */
    brandMapSlug?: string;
    /**
     * CDN URL of the brand logo for header/navbar rendering. Resolves in priority order — the per-challenge `brandLogo` Asset (admin override) first, then the linked `brandId → Brand.logo` Asset. Undefined when neither is set.
     * @type {string}
     * @memberof Challenge
     */
    brandLogoUrl?: string;
    /**
     * CDN URL for large background image asset
     * @type {string}
     * @memberof Challenge
     */
    backgroundImageLargeUrl?: string;
    /**
     * CDN URL for small background image asset
     * @type {string}
     * @memberof Challenge
     */
    backgroundImageSmallUrl?: string;
    /**
     * CDN URL for prize pool feature image asset
     * @type {string}
     * @memberof Challenge
     */
    prizePoolFeatureImageUrl?: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof Challenge
     */
    challengeType?: ChallengeType;
    /**
     * 
     * @type {ChallengePageMode}
     * @memberof Challenge
     */
    pageMode?: ChallengePageMode;
    /**
     * URL-friendly identifier for the challenge (e.g., "my-brand-challenge")
     * @type {string}
     * @memberof Challenge
     */
    slug?: string;
    /**
     * External URL for challenge landing page (e.g., "https://my-campaign.gg"). When set, promotional cards open this URL in a new window instead of navigating internally.
     * @type {string}
     * @memberof Challenge
     */
    landingPageUrl?: string;
    /**
     * Whether the challenge requires DevourPlay app to be installed
     * @type {boolean}
     * @memberof Challenge
     */
    requiresDevourPlay?: boolean;
    /**
     * 
     * @type {ChallengeThemeColors}
     * @memberof Challenge
     */
    themeColors?: ChallengeThemeColors;
    /**
     * 
     * @type {ChallengeTypography}
     * @memberof Challenge
     */
    typography?: ChallengeTypography;
    /**
     * 
     * @type {PageHeroSection}
     * @memberof Challenge
     */
    heroSection?: PageHeroSection;
    /**
     * 
     * @type {ChallengeVideoSection}
     * @memberof Challenge
     */
    videoSection?: ChallengeVideoSection;
    /**
     * Custom HTML content sections
     * @type {Array<ChallengeContentSection>}
     * @memberof Challenge
     */
    contentSections?: Array<ChallengeContentSection>;
    /**
     * 
     * @type {PageSeo}
     * @memberof Challenge
     */
    seo?: PageSeo;
    /**
     * Asset ID for default user avatar (shown when user has no profile pic, in leaderboards etc)
     * @type {string}
     * @memberof Challenge
     */
    defaultAvatarImageId?: string;
    /**
     * CDN URL for default avatar image (in response)
     * @type {string}
     * @memberof Challenge
     */
    defaultAvatarImageUrl?: string;
    /**
     * 
     * @type {ChallengeEmailConfig}
     * @memberof Challenge
     */
    emailConfig?: ChallengeEmailConfig;
    /**
     * Optional https webhook URL for challenge-specific operational alerts. Per-challenge so each brand engagement routes its own support signal to its own destination (Slack incoming webhook, Discord webhook, internal endpoint, etc.) without a backend env var change. Skipped silently when unset (audit log still writes). **Write-only** — the model marks the property `select:false` AND the `ChallengeResponse` interface omits it; the field is structurally absent from every client response and is set via the admin CREATE/UPDATE body only.
     * @type {string}
     * @memberof Challenge
     */
    notificationWebhookUrl?: string;
    /**
     * Optional reference to a Brand entity for brand assignment
     * @type {string}
     * @memberof Challenge
     */
    brandId?: string;
    /**
     * Link to unified BrandActivation record (auto-created, type BRAND_CHALLENGE)
     * @type {string}
     * @memberof Challenge
     */
    brandActivationId?: string;
    /**
     * Brand name (populated from brandId when available)
     * @type {string}
     * @memberof Challenge
     */
    brandName?: string;
    /**
     * Challenge start timestamp (computed from earliest segment startAt)
     * @type {number}
     * @memberof Challenge
     */
    start?: number;
    /**
     * Challenge end timestamp (computed from latest segment endAt)
     * @type {number}
     * @memberof Challenge
     */
    end?: number;
    /**
     * 
     * @type {ChallengeGrandPrize}
     * @memberof Challenge
     */
    grandPrize?: ChallengeGrandPrize;
    /**
     * 
     * @type {ChallengeCommunityGoalResponse}
     * @memberof Challenge
     */
    communityGoal?: ChallengeCommunityGoalResponse;
    /**
     * 
     * @type {ChallengePromotionsSectionConfig}
     * @memberof Challenge
     */
    promotionsSection?: ChallengePromotionsSectionConfig;
    /**
     * Custom HTML content for left side of FAQ section
     * @type {string}
     * @memberof Challenge
     */
    faqLeftContent?: string;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof Challenge
     */
    faqStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof Challenge
     */
    onboardingStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof Challenge
     */
    prizeSectionStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof Challenge
     */
    entriesColumnStyles?: ChallengeSectionStyleConfig;
    /**
     * 
     * @type {ChallengeSectionStyleConfig}
     * @memberof Challenge
     */
    questsStyles?: ChallengeSectionStyleConfig;
    /**
     * Custom HTML injected into the `<head>` of the challenge page.
     * @type {string}
     * @memberof Challenge
     */
    customHeadHtml?: string;
    /**
     * Custom HTML injected into the `<body>` of the challenge page.
     * @type {string}
     * @memberof Challenge
     */
    customBodyHtml?: string;
    /**
     * 
     * @type {PageNavbarConfig}
     * @memberof Challenge
     */
    navbarConfig?: PageNavbarConfig;
    /**
     * Optional GamificationModel ID (e.g. WHEEL_SPIN) wired to this challenge for interactive reward mechanics
     * @type {string}
     * @memberof Challenge
     */
    gamificationModelId?: string;
    /**
     * Optional uppercase prefix prepended to challenge-scoped referral codes (e.g. "RTTR" → RTTR12345). When set, codes generated for this challenge use a 5-digit numeric suffix; when unset, the platform short-uuid format is used.
     * @type {string}
     * @memberof Challenge
     */
    referralCodePrefix?: string;
    /**
     * 
     * @type {ChallengeReferralBonus}
     * @memberof Challenge
     */
    referralBonus?: ChallengeReferralBonus;
    /**
     * Optional whitelist of signup methods exposed on ChallengeLoginModal. Empty/undefined renders all methods (legacy behavior). When set, only providers in this list are shown — e.g. ["EMAIL"] hides social signup entirely.
     * @type {Array<SignupMethod>}
     * @memberof Challenge
     */
    allowedSignupMethods?: Array<SignupMethod>;
    /**
     * Cumulative-point thresholds (across all of this challenge's activations + segments) at which the user is granted a wheel spin via the gamificationModelId. Idempotent — each threshold awarded at most once per user. Empty/undefined disables milestone-triggered spins; the standard time-window reset on the GamificationModel still applies if configured. The model's stored default is an empty array — no platform-wide thresholds.
     * @type {Array<number>}
     * @memberof Challenge
     */
    wheelMilestoneThresholds?: Array<number>;
}



/**
 * Check if a given object implements the Challenge interface.
 */
export function instanceOfChallenge(value: object): value is Challenge {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ChallengeFromJSON(json: any): Challenge {
    return ChallengeFromJSONTyped(json, false);
}

export function ChallengeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Challenge {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'name': json['name'],
        'cardTitle': json['cardTitle'] == null ? undefined : json['cardTitle'],
        'description': json['description'],
        'backgroundImageLarge': json['backgroundImageLarge'] == null ? undefined : json['backgroundImageLarge'],
        'backgroundImageSmall': json['backgroundImageSmall'] == null ? undefined : json['backgroundImageSmall'],
        'brandLogo': json['brandLogo'] == null ? undefined : json['brandLogo'],
        'brandColor': json['brandColor'] == null ? undefined : json['brandColor'],
        'textColor': json['textColor'] == null ? undefined : json['textColor'],
        'disclaimerTitle': json['disclaimerTitle'] == null ? undefined : json['disclaimerTitle'],
        'disclaimerDescription': json['disclaimerDescription'] == null ? undefined : json['disclaimerDescription'],
        'hasEnded': json['hasEnded'] == null ? undefined : json['hasEnded'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isAdminOnly': json['isAdminOnly'] == null ? undefined : json['isAdminOnly'],
        'showPromoCard': json['showPromoCard'] == null ? undefined : json['showPromoCard'],
        'numberOfEntrants': json['numberOfEntrants'] == null ? undefined : json['numberOfEntrants'],
        'termsUrl': json['termsUrl'] == null ? undefined : json['termsUrl'],
        'termsContent': json['termsContent'] == null ? undefined : json['termsContent'],
        'onboardingSection': json['onboardingSection'] == null ? undefined : ChallengeOnboardingFromJSON(json['onboardingSection']),
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(ChallengeFaqDetailsFromJSON)),
        'eligibilityCheckboxes': json['eligibilityCheckboxes'] == null ? undefined : ((json['eligibilityCheckboxes'] as Array<any>).map(ChallengeEligibilityCheckboxFromJSON)),
        'eligibilityGeo': json['eligibilityGeo'] == null ? undefined : ChallengeEligibilityGeoFromJSON(json['eligibilityGeo']),
        'eligibilityConfig': json['eligibilityConfig'] == null ? undefined : EligibilityConfigFromJSON(json['eligibilityConfig']),
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(ChallengeSegmentFromJSON)),
        'draws': json['draws'] == null ? undefined : ((json['draws'] as Array<any>).map(ChallengeDrawFromJSON)),
        'prizePoolFeatureImage': json['prizePoolFeatureImage'] == null ? undefined : json['prizePoolFeatureImage'],
        'titleFontSize': json['titleFontSize'] == null ? undefined : json['titleFontSize'],
        'brandMapSlug': json['brandMapSlug'] == null ? undefined : json['brandMapSlug'],
        'brandLogoUrl': json['brandLogoUrl'] == null ? undefined : json['brandLogoUrl'],
        'backgroundImageLargeUrl': json['backgroundImageLargeUrl'] == null ? undefined : json['backgroundImageLargeUrl'],
        'backgroundImageSmallUrl': json['backgroundImageSmallUrl'] == null ? undefined : json['backgroundImageSmallUrl'],
        'prizePoolFeatureImageUrl': json['prizePoolFeatureImageUrl'] == null ? undefined : json['prizePoolFeatureImageUrl'],
        'challengeType': json['challengeType'] == null ? undefined : ChallengeTypeFromJSON(json['challengeType']),
        'pageMode': json['pageMode'] == null ? undefined : ChallengePageModeFromJSON(json['pageMode']),
        'slug': json['slug'] == null ? undefined : json['slug'],
        'landingPageUrl': json['landingPageUrl'] == null ? undefined : json['landingPageUrl'],
        'requiresDevourPlay': json['requiresDevourPlay'] == null ? undefined : json['requiresDevourPlay'],
        'themeColors': json['themeColors'] == null ? undefined : ChallengeThemeColorsFromJSON(json['themeColors']),
        'typography': json['typography'] == null ? undefined : ChallengeTypographyFromJSON(json['typography']),
        'heroSection': json['heroSection'] == null ? undefined : PageHeroSectionFromJSON(json['heroSection']),
        'videoSection': json['videoSection'] == null ? undefined : ChallengeVideoSectionFromJSON(json['videoSection']),
        'contentSections': json['contentSections'] == null ? undefined : ((json['contentSections'] as Array<any>).map(ChallengeContentSectionFromJSON)),
        'seo': json['seo'] == null ? undefined : PageSeoFromJSON(json['seo']),
        'defaultAvatarImageId': json['defaultAvatarImageId'] == null ? undefined : json['defaultAvatarImageId'],
        'defaultAvatarImageUrl': json['defaultAvatarImageUrl'] == null ? undefined : json['defaultAvatarImageUrl'],
        'emailConfig': json['emailConfig'] == null ? undefined : ChallengeEmailConfigFromJSON(json['emailConfig']),
        'notificationWebhookUrl': json['notificationWebhookUrl'] == null ? undefined : json['notificationWebhookUrl'],
        'brandId': json['brandId'] == null ? undefined : json['brandId'],
        'brandActivationId': json['brandActivationId'] == null ? undefined : json['brandActivationId'],
        'brandName': json['brandName'] == null ? undefined : json['brandName'],
        'start': json['start'] == null ? undefined : json['start'],
        'end': json['end'] == null ? undefined : json['end'],
        'grandPrize': json['grandPrize'] == null ? undefined : ChallengeGrandPrizeFromJSON(json['grandPrize']),
        'communityGoal': json['communityGoal'] == null ? undefined : ChallengeCommunityGoalResponseFromJSON(json['communityGoal']),
        'promotionsSection': json['promotionsSection'] == null ? undefined : ChallengePromotionsSectionConfigFromJSON(json['promotionsSection']),
        'faqLeftContent': json['faqLeftContent'] == null ? undefined : json['faqLeftContent'],
        'faqStyles': json['faqStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['faqStyles']),
        'onboardingStyles': json['onboardingStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['onboardingStyles']),
        'prizeSectionStyles': json['prizeSectionStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['prizeSectionStyles']),
        'entriesColumnStyles': json['entriesColumnStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['entriesColumnStyles']),
        'questsStyles': json['questsStyles'] == null ? undefined : ChallengeSectionStyleConfigFromJSON(json['questsStyles']),
        'customHeadHtml': json['customHeadHtml'] == null ? undefined : json['customHeadHtml'],
        'customBodyHtml': json['customBodyHtml'] == null ? undefined : json['customBodyHtml'],
        'navbarConfig': json['navbarConfig'] == null ? undefined : PageNavbarConfigFromJSON(json['navbarConfig']),
        'gamificationModelId': json['gamificationModelId'] == null ? undefined : json['gamificationModelId'],
        'referralCodePrefix': json['referralCodePrefix'] == null ? undefined : json['referralCodePrefix'],
        'referralBonus': json['referralBonus'] == null ? undefined : ChallengeReferralBonusFromJSON(json['referralBonus']),
        'allowedSignupMethods': json['allowedSignupMethods'] == null ? undefined : ((json['allowedSignupMethods'] as Array<any>).map(SignupMethodFromJSON)),
        'wheelMilestoneThresholds': json['wheelMilestoneThresholds'] == null ? undefined : json['wheelMilestoneThresholds'],
    };
}

export function ChallengeToJSON(json: any): Challenge {
    return ChallengeToJSONTyped(json, false);
}

export function ChallengeToJSONTyped(value?: Challenge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'cardTitle': value['cardTitle'],
        'description': value['description'],
        'backgroundImageLarge': value['backgroundImageLarge'],
        'backgroundImageSmall': value['backgroundImageSmall'],
        'brandLogo': value['brandLogo'],
        'brandColor': value['brandColor'],
        'textColor': value['textColor'],
        'disclaimerTitle': value['disclaimerTitle'],
        'disclaimerDescription': value['disclaimerDescription'],
        'hasEnded': value['hasEnded'],
        'isActive': value['isActive'],
        'isAdminOnly': value['isAdminOnly'],
        'showPromoCard': value['showPromoCard'],
        'numberOfEntrants': value['numberOfEntrants'],
        'termsUrl': value['termsUrl'],
        'termsContent': value['termsContent'],
        'onboardingSection': ChallengeOnboardingToJSON(value['onboardingSection']),
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(ChallengeFaqDetailsToJSON)),
        'eligibilityCheckboxes': value['eligibilityCheckboxes'] == null ? undefined : ((value['eligibilityCheckboxes'] as Array<any>).map(ChallengeEligibilityCheckboxToJSON)),
        'eligibilityGeo': ChallengeEligibilityGeoToJSON(value['eligibilityGeo']),
        'eligibilityConfig': EligibilityConfigToJSON(value['eligibilityConfig']),
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(ChallengeSegmentToJSON)),
        'draws': value['draws'] == null ? undefined : ((value['draws'] as Array<any>).map(ChallengeDrawToJSON)),
        'prizePoolFeatureImage': value['prizePoolFeatureImage'],
        'titleFontSize': value['titleFontSize'],
        'brandMapSlug': value['brandMapSlug'],
        'brandLogoUrl': value['brandLogoUrl'],
        'backgroundImageLargeUrl': value['backgroundImageLargeUrl'],
        'backgroundImageSmallUrl': value['backgroundImageSmallUrl'],
        'prizePoolFeatureImageUrl': value['prizePoolFeatureImageUrl'],
        'challengeType': ChallengeTypeToJSON(value['challengeType']),
        'pageMode': ChallengePageModeToJSON(value['pageMode']),
        'slug': value['slug'],
        'landingPageUrl': value['landingPageUrl'],
        'requiresDevourPlay': value['requiresDevourPlay'],
        'themeColors': ChallengeThemeColorsToJSON(value['themeColors']),
        'typography': ChallengeTypographyToJSON(value['typography']),
        'heroSection': PageHeroSectionToJSON(value['heroSection']),
        'videoSection': ChallengeVideoSectionToJSON(value['videoSection']),
        'contentSections': value['contentSections'] == null ? undefined : ((value['contentSections'] as Array<any>).map(ChallengeContentSectionToJSON)),
        'seo': PageSeoToJSON(value['seo']),
        'defaultAvatarImageId': value['defaultAvatarImageId'],
        'defaultAvatarImageUrl': value['defaultAvatarImageUrl'],
        'emailConfig': ChallengeEmailConfigToJSON(value['emailConfig']),
        'notificationWebhookUrl': value['notificationWebhookUrl'],
        'brandId': value['brandId'],
        'brandActivationId': value['brandActivationId'],
        'brandName': value['brandName'],
        'start': value['start'],
        'end': value['end'],
        'grandPrize': ChallengeGrandPrizeToJSON(value['grandPrize']),
        'communityGoal': ChallengeCommunityGoalResponseToJSON(value['communityGoal']),
        'promotionsSection': ChallengePromotionsSectionConfigToJSON(value['promotionsSection']),
        'faqLeftContent': value['faqLeftContent'],
        'faqStyles': ChallengeSectionStyleConfigToJSON(value['faqStyles']),
        'onboardingStyles': ChallengeSectionStyleConfigToJSON(value['onboardingStyles']),
        'prizeSectionStyles': ChallengeSectionStyleConfigToJSON(value['prizeSectionStyles']),
        'entriesColumnStyles': ChallengeSectionStyleConfigToJSON(value['entriesColumnStyles']),
        'questsStyles': ChallengeSectionStyleConfigToJSON(value['questsStyles']),
        'customHeadHtml': value['customHeadHtml'],
        'customBodyHtml': value['customBodyHtml'],
        'navbarConfig': PageNavbarConfigToJSON(value['navbarConfig']),
        'gamificationModelId': value['gamificationModelId'],
        'referralCodePrefix': value['referralCodePrefix'],
        'referralBonus': ChallengeReferralBonusToJSON(value['referralBonus']),
        'allowedSignupMethods': value['allowedSignupMethods'] == null ? undefined : ((value['allowedSignupMethods'] as Array<any>).map(SignupMethodToJSON)),
        'wheelMilestoneThresholds': value['wheelMilestoneThresholds'],
    };
}

